import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Lookup } from '@mrm/core';

export class SectoralMeetingExtension {
  selected: boolean;
  startDateTime: Date = new Date();
  lovSectoralMeetingStatus: Lookup[] = [];

  static getLookupForm(): FormGroup {
    const form = new FormGroup({
      firstName: new FormControl({ value: null, disabled: true }),
      lastName: new FormControl({ value: null, disabled: true }),
      conventionRegistrationSectoralMeetings: new FormArray([])
    });

    return form;
  }
}
